import withController from 'components/common/form-controlled/with-controller.hoc';
import withLabel from 'components/common/form-controlled/with-label.hoc';
import SensitiveTextInput, {
  type SensitiveTextInputProps
} from 'components/common/input-components/sensitive-text-input';

const ControlledSensitiveTextInput = withLabel(withController<SensitiveTextInputProps>(SensitiveTextInput));

export default ControlledSensitiveTextInput;
